import { render, staticRenderFns } from "./NavSection.vue?vue&type=template&id=5a8870a5&scoped=true"
import script from "./NavSection.vue?vue&type=script&lang=js"
export * from "./NavSection.vue?vue&type=script&lang=js"
import style0 from "./NavSection.vue?vue&type=style&index=0&id=5a8870a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8870a5",
  null
  
)

export default component.exports